import { CollectiveProcedures } from "@/components/collective-procedures.jsx";

const Procedures = () => {
  return (
    <div className="p-6">
      <CollectiveProcedures />
    </div>
  );
};

export default Procedures;
